/* AUTO GENERATED FILE. DO NOT MODIFY DIRECTLY!!!*/

export enum T {
  MEDIA_LABEL = 'media_label',
  ADD_MEDIA_LABEL = 'add_media_label',
  ADD_AUDIO_LABEL = 'add_audio_label',
  AI_IMAGE_LABEL = 'ai_image_label',
  AI_VIDEO_LABEL = 'ai_video_label',
  UPLOAD_LABEL = 'upload_label',
  UPLOAD_LABEL_SIDEBAR = 'upload_label_sidebar',
  MY_FILES_LABEL = 'my_files_label',
  RECENT_MEDIAS_LABEL = 'recent_medias_label',
  EXPORT_LABEL = 'export_label',
  MY_ACCOUNT_LABEL = 'my_account_label',
  HELP_AND_SUPPORT_LABEL = 'help_and_support_label',
  SIGN_OUT_LABEL = 'sign_out_label',
  VIDEOS_LABEL = 'videos_label',
  IMAGES_LABEL = 'images_label',
  MORE_LABEL = 'more_label',
  SETTINGS_LABEL = 'settings_label',
  LANGUAGE_LABEL = 'language_label',
  CREATED_IN_THIS_PROJECT_LABEL = 'created_in_this_project_label',
  EXPORT_DESCRIPTION_720 = 'export_description_720',
  EXPORT_DESCRIPTION_1080 = 'export_description_1080',
  EXPORT_DESCRIPTION_2160 = 'export_description_2160',
  PROJECT_DURATION_WARNING_MESSAGE = 'project_duration_warning_message',
  PROJECT_BETA_VERSION_DURATION_WARNING_MESSAGE = 'project_beta_version_duration_warning_message',
  OK_THANKS_LABEL = 'ok_thanks_label',
  SPLIT_LABEL = 'split_label',
  DELETE_LABEL = 'delete_label',
  DUPLICATE_LABEL = 'duplicate_label',
  ROTATE_LEFT_LABEL = 'rotate_left_label',
  ROTATE_RIGHT_LABEL = 'rotate_right_label',
  FIT_LABEL = 'fit_label',
  FILL_LABEL = 'fill_label',
  LAYER_ORDER_MENU_LABEL = 'layer_order_menu_label',
  GENERATE_LABEL = 'generate_label',
  HISTORY_LABEL = 'history_label',
  HISTORY_EMPTY_TITLE = 'history_empty_title',
  HISTORY_EMPTY_DESCRIPTION = 'history_empty_description',
  AUDIO_LABEL = 'audio_label',
  TEXT_LABEL = 'text_label',
  SEARCH_MUSIC_LABEL = 'search_music_label',
  NO_SEARCH_RESULT_DESCRIPTION = 'no_search_result_description',
  MY_MUSIC_LABEL = 'my_music_label',
  MUSIC_LIBRARY_LABEL = 'music_library_label',
  MORE_ACTIONS_LABEL = 'more_actions_label',
  RESET_LABEL = 'reset_label',
  HISTORY_EMPTY_DESCRIPTION_AI_VIDEO = 'history_empty_description_ai_video',
  ADD_TO_TIMELINE = 'add_to_timeline',
  OOPS_NOTHING_HERE = 'oops_nothing_here',
  DRAG_AND_DROP_A_FILE_OR_USE_UPLOAD_BUTTON = 'drag_and_drop_a_file_or_use_upload_button',
  YES_DROP_IT = 'yes_drop_it',
  CREATE_SIMILAR = 'create_similar',
  RE_GENERATE = 're_generate',
  USE_AS_REFERENCE = 'use_as_reference',
  ANIMATE = 'animate',
  DOWNLOAD = 'download',
  YES_DROP_LABEL = 'yes_drop_label',
  DRAG_DROP_TEXT = 'drag_drop_text',
  OR_LABEL = 'or_label',
  REMOVE_SOUND_FROM_LIBRARY = 'remove_sound_from_library',
  EDIT_LABEL = 'edit_label',
  CANCEL_LABEL = 'cancel_label',
  DELETE_SOUND_FROM_LIBRARY_WARNING_MESSAGE = 'delete_sound_from_library_warning_message',
  CLOSE_LABEL = 'close_label',
  CHARACTERS_ADVISED_LABEL = 'characters_advised_label',
  PREVIEW = 'preview',
  ZOOM_LABEL = 'zoom_label',
  IMAGE_PROMPT_TITLE = 'image_prompt_title',
  PROMPT_PLACEHOLDER = 'prompt_placeholder',
  MODEL_LABEL = 'model_label',
  SUPPORTS_AUDIO_GENERATION = 'supports_audio_generation',
  ASPECT_RATIO_LABEL = 'aspect_ratio_label',
  ADD_REFERENCE_MULTIPLE_IMAGES_TITLE = 'add_reference_multiple_images_title',
  ADD_REFERENCE_SINGLE_IMAGE_TITLE = 'add_reference_single_image_title',
  TEXT_TO_SPEECH_LABEL = 'text_to_speech_label',
  COMPLETED = 'completed',
  INACTIVE_GENERATE_BUTTON_TOOLTIP = 'inactive_generate_button_tooltip',
  WEEKLY_LITE_USER_TTS_LIMIT = 'weekly_lite_user_tts_limit',
  SUBSCRIBED_USER_TTS_CREDIT_LIMIT = 'subscribed_user_tts_credit_limit',
  FREE_USER_TTS_CREDIT_LIMIT = 'free_user_tts_credit_limit',
  TTS_CREDIT_LIMIT_EXPIRING_WARNING = 'tts_credit_limit_expiring_warning',
  CONTACT_SUPPORT = 'contact_support',
  CREDITS_WILL_BE_CHARGED = 'credits_will_be_charged',
  SELECT_LABEL = 'select_label',
  STYLES_LABEL = 'styles_label',
  RESTYLE_LABEL = 'restyle_label',
  SOMETHING_WENT_WRONG_LABEL = 'something_went_wrong_label',
  GOT_IT_LABEL = 'got_it_label',
  NOT_FOUND_PROJECT_ERROR_MESSAGE = 'not_found_project_error_message',
  GENERAL_API_ERROR_MESSAGE = 'general_api_error_message',
  VOICE = 'voice',
  SPEAKER_TONE_TOOLTIP_TEXT = 'speaker_tone_tooltip_text',
  SPEAKER_TOGGLER_TOOLTIP_TEXT = 'speaker_toggler_tooltip_text',
  TTS_VOICE_TONE = 'tts_voice_tone',
  MULTILINGUAL_LANGUAGE_TOOLTIP = 'multilingual_language_tooltip',
  TTS_DELETE_TOOLTIP = 'tts_delete_tooltip',
  TTS_TEXTS_TOOLTIP = 'tts_texts_tooltip',
  DEFAULT_SPEAKER = 'default_speaker',
  DEFAULT_SPEAKER_TOOLTIP = 'default_speaker_tooltip',
  SPEED = 'speed',
  CHANGE_SPEED = 'change_speed',
  SET_VOICE_TONE = 'set_voice_tone',
  SET_VOICE_TONE_TOOLTIP = 'set_voice_tone_tooltip',
  MALE = 'male',
  FEMALE = 'female',
  BACK = 'back',
  SAVE = 'save',
  CANCEL = 'cancel',
  SAVE_CHANGES_ALERT_TOOLTIP = 'save_changes_alert_tooltip',
  TEXTS = 'texts',
  CHANGE_SPEAKER = 'change_speaker',
  EDIT_AUDIO = 'edit_audio',
  VOLUME = 'volume',
  REMOVE = 'remove',
  VERSIONS = 'versions',
  TRACK = 'track',
  SECOND = 'second',
  MINUTE = 'minute',
  SECONDS = 'seconds',
  MINUTES = 'minutes',
  PROMPT = 'prompt',
  EDIT_AI_VIDEO = 'edit_ai_video',
  EDIT_AI_IMAGE = 'edit_ai_image',
  EXPORT_DISABLE_LABEL = 'export_disable_label',
  SOURCE_LABEL = 'source_label',
  PROJECT_MAX_DURATION_EXCEEDED_TITLE = 'project_max_duration_exceeded_title',
  PROJECT_MAX_DURATION_EXCEEDED_DESCRIPTION = 'project_max_duration_exceeded_description',
  AI_VIDEO_GENERATION_FAILED_TITLE = 'ai_video_generation_failed_title',
  AI_VIDEO_GENERATION_FAILED_DESCRIPTION = 'ai_video_generation_failed_description',
  GENERATION_FAILED = 'generation_failed',
  AI_IMAGE_GENERATION_FAILED_DESCRIPTION = 'ai_image_generation_failed_description',
  AI_MODERATION_FAILED_TITLE = 'ai_moderation_failed_title',
  AI_MODERATION_FAILED_DESCRIPTION = 'ai_moderation_failed_description',
  GET_MORE_MINUTES = 'get_more_minutes',
  ADD = 'add',
  TYPE_YOUR_TEXT = 'type_your_text',
  TTS_GENERATION_ERROR_DESCRIPTION = 'tts_generation_error_description',
  ADD_PROMPT_OR_REFERENCE_IMAGE_TO_GENERATE = 'add_prompt_or_reference_image_to_generate',
  ADD_PROMPT_OR_START_FRAME_TO_GENERATE = 'add_prompt_or_start_frame_to_generate',
  SUPPORTED_FILE_TYPES_WARNING = 'supported_file_types_warning',
  UNSUPPORTED_FILE_FORMAT_DESCRIPTION = 'unsupported_file_format_description',
  ENTER_PROMPT_TO_GENERATE = 'enter_prompt_to_generate',
  REFERENCE_IMAGE_RESIZE_CREDITS = 'reference_image_resize_credits',
  REFERENCE_IMAGES_RESIZE_CREDITS = 'reference_images_resize_credits',
  UNDO = 'undo',
  REDO = 'redo',
  AI_CREDITS_LABEL = 'ai_credits_label',
  REFILL_CREDITS_LABEL = 'refill_credits_label',
  REFILL_LABEL = 'refill_label',
  SWITCH_TO_PORTRAIT_TITLE = 'switch_to_portrait_title',
  SWITCH_TO_WIDESCREEN_TITLE = 'switch_to_widescreen_title',
  ASPECT_RATIO_WARNING_DESCRIPTION = 'aspect_ratio_warning_description',
  SWITCH_LABEL = 'switch_label',
  WIDESCREEN_LABEL = 'widescreen_label',
  PORTRAIT_LABEL = 'portrait_label',
  UP_TO_LABEL = 'up_to_label',
  LET_S_CREATE_SOMETHING_AMAZING_LABEL = 'let_s_create_something_amazing_label',
  GENERATE_AI_VIDEO_LABEL = 'generate_ai_video_label',
  GENERATE_AI_IMAGE_LABEL = 'generate_ai_image_label',
  AI_CREATES_VIDEO_LABEL = 'ai_creates_video_label',
  AI_CREATES_IMAGE_LABEL = 'ai_creates_image_label',
  UPLOAD_YOUR_MEDIA_LABEL = 'upload_your_media_label',
  CONSISTENCY_DISABLED_FIELD_TOOLTIP = 'consistency_disabled_field_tooltip',
  ADD_REF_IMAGE_TO_CHOOSE_STYLE_TOOLTIP = 'add_ref_image_to_choose_style_tooltip',
  MANUAL_EDIT_LABEL = 'manual_edit_label',
  SMART_EDIT_LABEL = 'smart_edit_label',
  SMART_EDIT_PLACEHOLDER = 'smart_edit_placeholder',
  ANIMATE_IMAGE_TITLE = 'animate_image_title',
  ANIMATE_IMAGE_DESCRIPTION = 'animate_image_description',
  CUSTOM_ANIMATE = 'custom_animate',
  DELETE_AI_IMAGE_CONFIRMATION_TITLE = 'delete_ai_image_confirmation_title',
  DELETE_AI_IMAGE_CONFIRMATION_DESCRIPTION = 'delete_ai_image_confirmation_description',
  FLIP_HORIZONTAL_LABEL = 'flip_horizontal_label',
  RECOMMENDED_REF_IMAGE_SIZE_LABEL = 'recommended_ref_image_size_label',
  PREPARING_THE_VIDEO = 'preparing_the_video',
  SETTING_UP_THE_SCENES = 'setting_up_the_scenes',
  PLANNING_THE_MOTION = 'planning_the_motion',
  CREATING_THE_VIDEO = 'creating_the_video',
  RENDERING_FRAMES = 'rendering_frames',
  ADDING_MOVEMENT = 'adding_movement',
  PUTTING_IT_TOGETHER = 'putting_it_together',
  FINAL_FRAMES = 'final_frames',
  ALMOST_READY = 'almost_ready',
  FINISHING_THE_VIDEO = 'finishing_the_video',
  DRAMATIC_PAUSE = 'dramatic_pause',
  SO_CLOSE_YOU_CAN_ALMOST_SEE_IT = 'so_close_you_can_almost_see_it',
  OKAY_THIS_ONE_DETAIL_IS_BEING_STUBBORN = 'okay_this_one_detail_is_being_stubborn',
  JUST_PRETENDING_TO_BE_SLOW_NOW = 'just_pretending_to_be_slow_now',
  UPGRADE = 'upgrade',
  FULL_STORAGE_WARNING = 'full_storage_warning',
  FREEZE_FRAME_LABEL = 'freeze_frame_label',
  EDIT_IMAGE = 'edit_image',
  MAGNET_LABEL = 'magnet_label',
  GEN_AI_ENTRY_BUTTON_LABEL = 'gen_ai_entry_button_label',
  GEN_AI_ENTRY_TOOLTIP = 'gen_ai_entry_tooltip',
  SMART_PROJECT_MATCH = 'smart_project_match',
  SMART_PROJECT_MATCH_DESCRIPTION = 'smart_project_match_description',
  WELCOME_CANVAS_TITLE = 'welcome_canvas_title',
  WELCOME_CANVAS_SUBTITLE = 'welcome_canvas_subtitle',
  AI_HISTORY = 'ai_history',
  QUALITY_LABEL = 'quality_label',
  DURATION_LABEL = 'duration_label',
  FILTER_LABEL = 'filter_label',
  VIEW_ALL_LABEL = 'view_all_label',
  NO_RESULTS_FOUND_LABEL = 'no_results_found_label',
  NO_RESULTS_FOUND_DESCRIPTION_LABEL = 'no_results_found_description_label',
  NO_VIDEO_RESULTS_FOUND_DESCRIPTION = 'no_video_results_found_description',
  NO_IMAGE_RESULTS_FOUND_DESCRIPTION = 'no_image_results_found_description',
  CLEAR_FILTERS_LABEL = 'clear_filters_label',
  REFERENCE_IMAGES_LABEL = 'reference_images_label',
  VERSION_HISTORY_LABEL = 'version_history_label',
  NO_VERSION_HISTORY_LABEL = 'no_version_history_label',
  COPY_PROMPT_TOOLTIP = 'copy_prompt_tooltip',
  PREVIOUS_LABEL = 'previous_label',
  NEXT_LABEL = 'next_label',
  START_FRAME_LABEL = 'start_frame_label',
  END_FRAME_LABEL = 'end_frame_label',
  UPGRADE_TO_EXPORT_TOOLTIP = 'upgrade_to_export_tooltip',
  OPTIONAL_LABEL = 'optional_label',
  ADD_TEXT_LABEL = 'add_text_label',
  EDIT_YOUR_TEXT_LABEL = 'edit_your_text_label',
  TEXT_BODY_CONTENT_LABEL = 'text_body_content_label',
  TEXT_FONT_LABEL = 'text_font_label',
  TEXT_COLOR_LABEL = 'text_color_label',
  TEXT_SIZE_LABEL = 'text_size_label',
  STROKE_COLOR_LABEL = 'stroke_color_label',
  STROKE_WEIGHT_LABEL = 'stroke_weight_label',
  SELECT_FONT_LABEL = 'select_font_label',
  Z_ORDER_BRING_TO_FRONT = 'z_order_bring_to_front',
  Z_ORDER_BRING_TO_BACK = 'z_order_bring_to_back',
  Z_ORDER_BRING_FORWARD = 'z_order_bring_forward',
  Z_ORDER_BRING_BACKWARD = 'z_order_bring_backward',
  ALL_LABEL = 'all_label',
  GET_UNLIMITED_GENERATIONS_BANNER = 'get_unlimited_generations_banner',
  GET_UNLIMITED_HD_GENERATIONS_BANNER = 'get_unlimited_hd_generations_banner',
  UPGRADE_UNLIMITED_GENERATIONS_BANNER = 'upgrade_unlimited_generations_banner',
  UNLIMITED_LABEL = 'unlimited_label',
  ORIGINAL_LABEL = 'original_label',
  ORIGINAL_REF_IMAGE_SIZE_LABEL = 'original_ref_image_size_label',
  ORIGINAL_REF_IMAGE_SIZE_SUFFIX_LABEL = 'original_ref_image_size_suffix_label',
  AUTO_RESIZE_REF_IMAGE_TOOLTIP = 'auto_resize_ref_image_tooltip',
  CREDITS_LABEL = 'credits_label',
  REFERENCES_LABEL = 'references_label',
  UP_TO_FILES_LABEL = 'up_to_files_label',
  START_END_FRAME_LABEL = 'start_end_frame_label',
  SUPPORTED_FORMATS_LABEL = 'supported_formats_label',
  POWER_MODE_LABEL = 'power_mode_label',
  POWER_MODE_TOOLTIP = 'power_mode_tooltip',
  POWER_MODE_GENERATING_TITLE = 'power_mode_generating_title',
  POWER_MODE_GENERATING_DESCRIPTION = 'power_mode_generating_description',
  POWER_MODE_GENERATING_DESCRIPTION_FREE = 'power_mode_generating_description_free',
  WAIT_LABEL = 'wait_label',
  TURN_ON_POWER_MODE_LABEL = 'turn_on_power_mode_label'
}

/* AUTO GENERATED FILE. DO NOT MODIFY !!! */
